import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';
import { debugTimeStart, debugTimeEnd } from 'utils/utils';

/**
 * A helper for calling Firebase Functions with debug timers and optional response transforms.
 * @param {string} funcName - The name of the Firebase cloud function endpoint.
 * @param {object} data - The request payload.
 * @param {object} options - Additional config.
 * @param {string} options.debugLabel - Name for debugging (used in debugTimeStart/End).
 * @param {number} [options.timeout=60000] - Function call timeout in milliseconds.
 * @param {function} [options.transformResponse] - A callback to transform the response before returning it.
 * @returns {Promise<any>}
 */
export const callFirebaseFunction = async function (
	funcName,
	data,
	{
		debugLabel,
		timeout = 60000,
		transformResponse,
	} = {}
) {
	debugTimeStart(debugLabel);
	
	try {
		
		if (process.env.REACT_APP_USE_RTD_EMULATOR === 'true') {
      firebase.functions().useFunctionsEmulator('http://localhost:5005');
    }
		else if (process.env.NODE_ENV === 'development') {
			firebase.functions().useFunctionsEmulator('http://localhost:5001');
		}
		
		const callable = firebase.functions().httpsCallable(funcName, { timeout });
		const response = await callable(data);
		// By default, return response.data; otherwise, apply the transformResponse callback if provided
		return typeof transformResponse === 'function'
			? transformResponse(response)
			: response.data;
	} catch (error) {
		// Consistently throw the entire error object
		throw error;
	} finally {
		debugTimeEnd(debugLabel);
	}
}